import { render } from "./DashboardMobile.vue?vue&type=template&id=6a671282"
import script from "./DashboardMobile.vue?vue&type=script&lang=js"
export * from "./DashboardMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/application/dashboards/DashboardMobile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a671282"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a671282', __exports__)) {
    api.reload('6a671282', __exports__)
  }
  
  module.hot.accept("./DashboardMobile.vue?vue&type=template&id=6a671282", () => {
    api.rerender('6a671282', render)
  })

}


export default __exports__